import OperationRepository from '@/libs/customAxios/operationAxios'

const aiSettingsResource = '/merchant/settings/ai'

export default {
  getAiSetting() {
    return OperationRepository.get(`${aiSettingsResource}`)
  },
}
